module.exports = __webpack_public_path__ + "static/media/poppins-bold-webfont.1544e693.ttf";